<template>
  <div id="app" class="app-wrapper app-root">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <button id="ducedesk-chat-btn" class="open-button" v-on:click="openForm">Phone</button>
    <div class="chat-popup" id="myForm">
       <span class="close-btn" v-on:click="closeForm">&times;</span>
        <iframe src="https://sgvkcavywcp02.fullertonhealth.com/ctiapp/" width="350px" height="550px" style="border: none"></iframe>
     </div>
    <woot-snackbar-box />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import WootSnackbarBox from './components/SnackbarContainer';
import { accountIdFromPathname } from './helper/URLHelper';

export default {
  name: 'App',

  components: {
    WootSnackbarBox,
  },

  computed: {
    ...mapGetters({
      getAccount: 'accounts/getAccount',
    }),
  },

  mounted() {
    this.$store.dispatch('setUser');
    this.setLocale(window.chatwootConfig.selectedLocale);
    this.initializeAccount();
    
  },

  methods: {
    setLocale(locale) {
      this.$root.$i18n.locale = locale;
    },

    async initializeAccount() {
      const { pathname } = window.location;
      const accountId = accountIdFromPathname(pathname);
      if (accountId) {
        await this.$store.dispatch('accounts/get');
        const { locale } = this.getAccount(accountId);
        this.setLocale(locale);
      }
     document.getElementById("ducedesk-chat-btn").style.backgroundColor='#1f93ff';
     document.getElementById("close-btn").style.fontSize='small';
    },
    openForm(){
        document.getElementById("ducedesk-chat-btn").style.opacity = 0; //hide button while opening
        document.getElementById("myForm").style.display = "block";
    },
    closeForm(){
        document.getElementById("ducedesk-chat-btn").style.opacity = 1; //enable button on close
        document.getElementById("myForm").style.display = "none";
    }
  },
};
</script>

<style scoped>
iframe {
  border: none;
}

.open-button {
  background-color: #1f93ff !important;
  font-family: inherit;
  font-weight: bold;
  border-radius: 8px;
  color: white;
  padding: 16px 20px;
  border: none;
  cursor: pointer;
  opacity: 0.8;
  position: fixed;
  bottom: 23px;
  right: 28px;
}

.chat-popup {
  display: none;
  position: fixed;
  bottom: 0;
  right: 15px;
  border: 3px solid #f1f1f1;
  z-index: 9;
  border-radius: 16px;
}

.form-container .btn:hover,
.open-button:hover {
  opacity: 1;
}

.close-btn {
  font-weight: bold;
  color: #000;
  cursor: pointer;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  margin-right: 5px;
  font-size:small !important;
}
</style>

<style lang="scss">
@import './assets/scss/app';
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
